module.exports = __webpack_public_path__ + "img/arrow-right-circle.4edf1106.svg";